import { format } from 'date-fns';

export const formatDate = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

export const formattedDate = (date: Date, format: string) => {
  const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
  const symbol = {
    M: date.getMonth() + 1,
    d: date.getDate(),
    H: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    E: weekdays[date.getDay()],
  };

  const formatted = format.replace(/(M+|d+|H+|m+|s+|E+)/g, (v) => {
    const key = v.slice(-1) as keyof typeof symbol;
    if (key === 'E') return symbol[key];
    return ((v.length > 1 ? '0' : '') + symbol[key]).slice(-2);
  });

  return formatted.replace(/(y+)/g, (v) => date.getFullYear().toString().slice(-v.length));
};
